import * as React from 'react';

function Welcome(props) {

    return(
        <div className="welcome">
                <span className="highlight">Ahorra tiempo </span>en tus <span className="highlight">procesos judiciales</span>
        </div>
    )
}

export { Welcome }